import { render, staticRenderFns } from "./LaborCostPerModule.vue?vue&type=template&id=29990e58&scoped=true&"
import script from "./LaborCostPerModule.vue?vue&type=script&lang=js&"
export * from "./LaborCostPerModule.vue?vue&type=script&lang=js&"
import style0 from "./LaborCostPerModule.vue?vue&type=style&index=0&id=29990e58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29990e58",
  null
  
)

export default component.exports